const machine_txt = {
    type: "VA-600D-35ZD-7/300",
    name: "Fully Automatic Hem Folding Machine",
    description: [
        "Application",
        "Suitable for knitted fabrics such as plain knit, pique, rib,and bamboo-coton blends, including T-shirts, polo shirts,tank tops, and thermal undervear.",
        "Functional Characteristics",
        "Automatic size identification, assorting and controlling; Automatic start-stop, trim thread, align overlapping stitches.",
        "Addingseam position detection device locates the position of start & end stitching and avoid false detection for fabric colour as well.",
        "The seam control mechanism can realize the both side into the real same seam direction.",
        "Correcting device sensure the same seam directions are well aligned outside and inside.",
        "Automatic adjust the hem edge size range.",
        "loT can be realized.",
    ],
    //绝对路径
    machine_img:[
        "/assets/machine/17/machine_img/1.jpg",
    ], 
    machine_other_img:[
        "/assets/machine/17/machine_other/1.png",
        "/assets/machine/17/machine_other/2.png",
        "/assets/machine/17/machine_other/3.png",
    ]
}
export default {machine_txt}